import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ApplicationForm from "@/components/application/ApplicationForm.vue";
import { Actions } from "@/store";
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditApplicationPage',
  setup(__props) {

const store = useStore();
const route = useRoute();

onMounted(() => {
  if (route.params.id) {
    store.dispatch(Actions.GetApplication, route.params.id);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ApplicationForm))
}
}

})